// extracted by mini-css-extract-plugin
export var text = "_14-0";